import { AxiosResponse } from "axios";
import { Requests } from "../../config/api";
import {
  CreateCompanyProps,
  CreateCompanyReturnType,
  GetInsuranceProvidersProps,
} from "../../declarations/companyServices";
import { postRequest } from "../commonActions/post";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { putRequest } from "../commonActions/update";
import { getRequest } from "../commonActions/get";
import { deleteRequest } from "../commonActions/delete";

export const CreateCompany = async ({
  setLoading,
  payload,
  profileId,
}: CreateCompanyProps | any): Promise<CreateCompanyReturnType> => {
  if (payload instanceof FormData) {
    console.log("FormData contents:");
    payload.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
  } else {
    console.error("Payload is not FormData!");
  }

  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await putRequest({
      route: `${Requests.update.createCompany}/${profileId}`,
      formData: true,
      payload,
    });
    setLoading && setLoading(false);

    const company = response?.data?.company;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      company,
      errors,
      message: message,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const CreateInsuranceProvider = async ({
  payload,
}: {
  payload: any;
}) => {
  try {
    const response: AxiosResponse = await postRequest({
      route: Requests.post.insuranceProvider,
      payload,
      // headers: { 'Content-Type': 'multipart/form-data' },
    });

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;

    return {
      status,
      message,
      errors,
    };
  } catch (error) {
    console.error("Error in CreateInsuranceProvider:", error);
    throw error;
  }
};

export const GetAllInsuranceProviders = async ({
  page,
  limit,
}: {
  page: number;
  limit: number;
}): Promise<any> => {
  try {
    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getMyProviders}?page=${page}&limit=${limit}`,
    });
    console.log("Raw insurance API Response:", response);

    const insurance_provider = response?.data?.insurance_provider;
    const totalData = response?.data?.totalData; // Extract total data
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;

    return {
      status,
      insurance_provider,
      totalData, // Include total data in the return object
      errors,
      message,
    };
  } catch (error) {
    console.error("Error in GetAllInsuranceProviders:", error);
    throw error;
  }
};

export const DeleteInsuranceProvider = async (query: {
  id: string;
  setLoading: (loading: boolean) => void;
}): Promise<any> => {
  try {
    query.setLoading && query.setLoading(true);
    const response: AxiosResponse = await deleteRequest({
      route: `${Requests.delete.deleteProviders}/${query.id}`,
    });
    query.setLoading && query.setLoading(false);

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;
    const success = status === 200; // Check if the operation was successful

    return {
      success, // Include success in the return object
      status,
      message,
      errors,
    };
  } catch (error) {
    query.setLoading && query.setLoading(false);
    console.error("Error in DeleteInsuranceProvider:", error);
    return {
      success: false,
      message: "Failed to delete insurance provider",
      errors: [],
    };
  }
};

export const UpdateInsuranceProvider = async ({
  id,
  payload,
}: {
  id: string;
  payload: any;
}): Promise<any> => {
  try {
    const response: AxiosResponse = await putRequest({
      route: `${Requests.update.updateProviders}/${id}`,
      payload,
    });

    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;

    return {
      status,
      message,
      errors,
    };
  } catch (error) {
    console.error("Error in UpdateInsuranceProvider:", error);
    throw error;
  }
};
